import React from 'react';
export function DealFlowFooter() {
  return <footer className="bg-charcoal-dark text-slate-light pt-16 pb-8 border-t border-charcoal-light" data-id="element-147">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-148">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12" data-id="element-149">
          <div data-id="element-150">
            <h3 className="font-editorial text-2xl tracking-widest uppercase mb-4 text-white" data-id="element-151">
              Cabo Deal Flow
            </h3>
            <p className="text-sm max-w-md mb-6 font-light leading-relaxed" data-id="element-152">
              Curated, independently analyzed real estate investment deal flow
              in Los Cabos. Data-driven. Privacy-first.
            </p>
            <p className="text-sm" data-id="element-153">
              Contact:{' '}
              <a href="mailto:deals@cabodealflow.com" className="text-gold hover:text-white transition-colors" data-id="element-154">
                deals@cabodealflow.com
              </a>
            </p>
          </div>

          <div className="md:text-right" data-id="element-155">
            <h4 className="font-editorial text-lg mb-4 text-white" data-id="element-156">
              Sister Platform
            </h4>
            <p className="text-sm mb-4" data-id="element-157">
              Looking for lifestyle real estate and vetted professionals?
            </p>
            <a href="/" className="inline-block border border-slate-light px-6 py-2 text-xs uppercase tracking-widest hover:border-gold hover:text-gold transition-colors" data-id="element-158">
              Visit CaboCollection.com
            </a>
          </div>
        </div>

        <div className="border-t border-charcoal pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-slate" data-id="element-159">
          <p className="mb-4 md:mb-0 max-w-2xl" data-id="element-160">
            Disclaimer: This is not financial advice. All investment decisions
            should be made with your own due diligence. Projections are
            estimates based on current market data and are not guaranteed.
          </p>
          <p className="shrink-0" data-id="element-161">
            &copy; {new Date().getFullYear()} Cabo Deal Flow.
          </p>
        </div>
      </div>
    </footer>;
}